<template>
  <div class="chart-container">
    <div class="chart-bg">
      <div class="chart" ref="charts" ></div>
    </div>
  </div>
</template>

<script>
// import * as echarts5 from 'echarts5'
// import 'echarts-gl2' // 3d图表库
import * as echarts from 'echarts'
import 'echarts-gl' // 3d图表库
import { getPie3D, getParametricEquation } from '@/utils/3DChart.js' // 工具类js，页面路径自己修改

export default {
  name: 'pieChart',
  props: {
    optionData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      option: {},
      optionsValue: [],
      color: ['rgba(0, 120, 164, 1)', 'rgba(196, 147, 0, 1)', 'rgba(0, 194, 116, 1)'],
      fontColor: ['rgba(0, 187, 255, 1)', 'rgba(255, 191, 0, 1)', 'rgba(0, 255, 153, 1)'],
      charts: null,
    }
  },
  computed: {},
  watch: {
    optionData: {
      handler(newVal, old) {
        // console.log('optionData::', this.optionData);
        // console.log('optionData.newVal::', newVal);
        this.$nextTick(() => {
          this.removeBind()
          this.setLabel()
          this.initChart()
        })
      },
      deep: true
    },
    // option() {
    //   this.initChart()
    // }
  },
  mounted() {
    window.addEventListener('resize', this.resize)
    this.$nextTick(() => {
      this.init = true
      if (this.optionsValue.length === 1 && this.optionsValue[0].value === 0) {
        return
      }
      this.setLabel()
      this.initChart()
    })
  },
  activated() {
    this.resize()
  },
  updated() {
    this.resize()
  },
  beforeDestroy() {
    this.charts && this.charts.dispose()
    window.removeEventListener('resize', this.resize)
    this.charts = null
  },
  methods: {
    resize() {
      this.charts && this.charts.resize()
    },
    // 初始化label样式
    setLabel() {
      this.optionsValue = JSON.parse(JSON.stringify(this.optionData))
      this.optionsValue.forEach((item, index) => {
        item.itemStyle = {
          color: this.color[index]
        }
        item.label = {
          normal: {
            padding: [-36, -100, 0],
            show: item.value != 0 ? true : false,
            color: this.color[index],
            formatter: [
              '\n{b|{b}}  {d|{d}%}',
              '{c|{c}人}\n'
            ].join('\n'), // 用\n来换行
            rich: {
              b: {
                color: 'rgba(148, 255, 218, 1)',
                lineHeight: 16,
                align: 'left',
                fontSize: 12,
                padding: [0, 0, 0, 0],
                fontFamily: 'MicrosoftYaHei'
              },
              c: {
                fontSize: 12,
                color: this.fontColor[index],
                align: 'right',
                fontFamily: 'MicrosoftYaHei',
                lineHeight: 16,
              },
              d: {
                // color: color[index],
                color: '#fff',
                align: 'left',
                fontFamily: 'MicrosoftYaHei',
                fontSize: 12,
                lineHeight: 16,
              }
            }
          }, 
        }
        item.labelLine = {
          normal: {
            length: 10,
            length2: 126,
            lineStyle: {
              width: 1,
              color: 'rgba(255,255,255,0.5)'
            },
            show: item.value != 0 ? true : false,
          }
        }
      })
    },
    // 图表初始化
    initChart() {
      const chartDom = this.$refs.charts
      if(this.charts) {
        this.charts && this.charts.dispose()
        // window.removeEventListener('resize', this.resize)
        this.charts = null
      }
      this.charts = echarts.init(chartDom);
      this.option && this.charts.setOption(this.option)
      // this.option = getPie3D(this.optionsValue, 0.8, 156, 18, 16, 1)
      this.option = getPie3D(this.optionsValue, 0.8, 160, 34, 16, 1, 0.1)
      this.option.series.push({
        name: 'pie2d', // 自己根据场景修改
        backgroundColor: 'transparent',
        type: 'pie',
        label: {
          // padding: [-45, -60, 0],
          opacity: 1,
          fontSize: 12,
          fontFamily: 'Rajdhani',
        },
        labelLine: {
          length: 10,
          length2: 120
        },
        // startAngle: 130, // 起始角度，支持范围[0, 360]。
        startAngle: -50, // 起始角度，支持范围[0, 360]。
        avoidLabelOverlap: true,
        clockwise: false, // 饼图的扇区是否是顺时针排布。上述这两项配置主要是为了对齐3d的样式
        radius: ['50%', '40%'],
        center: ['46%', '64%'],
        data: this.optionsValue,
        itemStyle: {
          opacity: 0 // 这里必须是0，不然2d的图会覆盖在表面
        }
      })

      // this.bindListen(this.charts)
      this.charts.setOption(this.option, true)
    },
    // 监听鼠标事件，实现饼图选中效果（单选），近似实现高亮（放大）效果。
    // optionName是防止有多个图表进行定向option传递，单个图表可以不传，默认是opiton
    removeBind() {
      this.charts.off('click')
      this.charts.off('mouseover')
      this.charts.off('globalout')
    },
    bindListen(myChart) {
      // 监听鼠标事件，实现饼图选中效果（单选），近似实现高亮（放大）效果。
      let that = this;
      let selectedIndex = '';
      let hoveredIndex = '';
      // 监听点击事件，实现选中效果（单选）
      myChart.on('click', function(params) {
          // 从 option.series 中读取重新渲染扇形所需的参数，将是否选中取反。
          let isSelected = !that.option.series[params.seriesIndex].pieStatus.selected;
          let isHovered = that.option.series[params.seriesIndex].pieStatus.hovered;
          let k = that.option.series[params.seriesIndex].pieStatus.k;
          let startRatio = that.option.series[params.seriesIndex].pieData.startRatio;
          let endRatio = that.option.series[params.seriesIndex].pieData.endRatio;
          // 如果之前选中过其他扇形，将其取消选中（对 option 更新）
          if (selectedIndex !== '' && selectedIndex !== params.seriesIndex) {
              that.option.series[selectedIndex].parametricEquation = getParametricEquation(that.option.series[
                      selectedIndex].pieData
                  .startRatio, that.option.series[selectedIndex].pieData.endRatio, false, false, k, that.option.series[
                      selectedIndex].pieData
                  .value);
              that.option.series[selectedIndex].pieStatus.selected = false;
          }
          // 对当前点击的扇形，执行选中/取消选中操作（对 option 更新）
          that.option.series[params.seriesIndex].parametricEquation = getParametricEquation(startRatio, endRatio,
              isSelected,
              isHovered, k, that.option.series[params.seriesIndex].pieData.value);
          that.option.series[params.seriesIndex].pieStatus.selected = isSelected;
          // 如果本次是选中操作，记录上次选中的扇形对应的系列号 seriesIndex
          isSelected ? selectedIndex = params.seriesIndex : null;
          // 使用更新后的 option，渲染图表
          myChart.setOption(that.option);
      });
      // 监听 mouseover，近似实现高亮（放大）效果
      myChart.on('mouseover', function(params) {
          // 准备重新渲染扇形所需的参数
          let isSelected;
          let isHovered;
          let startRatio;
          let endRatio;
          let k;
          // 如果触发 mouseover 的扇形当前已高亮，则不做操作
          if (hoveredIndex === params.seriesIndex) {
              return;
              // 否则进行高亮及必要的取消高亮操作
          } else {
              // 如果当前有高亮的扇形，取消其高亮状态（对 option 更新）
              if (hoveredIndex !== '') {
                  // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 false。
                  isSelected = that.option.series[hoveredIndex].pieStatus.selected;
                  isHovered = false;
                  startRatio = that.option.series[hoveredIndex].pieData.startRatio;
                  endRatio = that.option.series[hoveredIndex].pieData.endRatio;
                  k = that.option.series[hoveredIndex].pieStatus.k;
                  // 对当前点击的扇形，执行取消高亮操作（对 option 更新）
                  that.option.series[hoveredIndex].parametricEquation = getParametricEquation(startRatio, endRatio,
                      isSelected,
                      isHovered, k, that.option.series[hoveredIndex].pieData.value);
                  that.option.series[hoveredIndex].pieStatus.hovered = isHovered;
                  // 将此前记录的上次选中的扇形对应的系列号 seriesIndex 清空
                  hoveredIndex = '';
              }
              // 如果触发 mouseover 的扇形不是透明圆环，将其高亮（对 option 更新）
              if (params.seriesName !== 'mouseoutSeries' && params.seriesName !== 'pie2d') {
                  // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 true。
                  isSelected = that.option.series[params.seriesIndex].pieStatus.selected;
                  isHovered = true;
                  startRatio = that.option.series[params.seriesIndex].pieData.startRatio;
                  endRatio = that.option.series[params.seriesIndex].pieData.endRatio;
                  k = that.option.series[params.seriesIndex].pieStatus.k;
                  // 对当前点击的扇形，执行高亮操作（对 option 更新）
                  that.option.series[params.seriesIndex].parametricEquation = getParametricEquation(startRatio, endRatio,
                      isSelected, isHovered, k, that.option.series[params.seriesIndex].pieData.value + 5);
                  that.option.series[params.seriesIndex].pieStatus.hovered = isHovered;
                  // 记录上次高亮的扇形对应的系列号 seriesIndex
                  hoveredIndex = params.seriesIndex;
              }
              // 使用更新后的 option，渲染图表
              myChart.setOption(that.option);
          }
      });
      // 修正取消高亮失败的 bug
      myChart.on('globalout', function() {
          // 准备重新渲染扇形所需的参数
          let isSelected;
          let isHovered;
          let startRatio;
          let endRatio;
          let k;
          if (hoveredIndex !== '') {
              // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 true。
              isSelected = that.option.series[hoveredIndex].pieStatus.selected;
              isHovered = false;
              k = that.option.series[hoveredIndex].pieStatus.k;
              startRatio = that.option.series[hoveredIndex].pieData.startRatio;
              endRatio = that.option.series[hoveredIndex].pieData.endRatio;
              // 对当前点击的扇形，执行取消高亮操作（对 option 更新）
              that.option.series[hoveredIndex].parametricEquation = getParametricEquation(startRatio, endRatio,
                  isSelected,
                  isHovered, k, that.option.series[hoveredIndex].pieData.value);
              that.option.series[hoveredIndex].pieStatus.hovered = isHovered;
              // 将此前记录的上次选中的扇形对应的系列号 seriesIndex 清空
              hoveredIndex = '';
          }
          // 使用更新后的 option，渲染图表
          myChart.setOption(that.option);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.chart-container {
  position: relative;
  width: 100%;
  height: vh(190);
  .chart-bg {
    width: 100%;
    height: vh(190);
    // background-image: url("../../../assets/images/socializationIcon/block/bg_chart.png");
    // background-repeat: no-repeat;
    // background-size: vw(148) vh(62);
    // background-position: vw(94) bottom;
    display: flex;
  }
  .chart {
    width: 100%;
    height: vh(180);
  }
}
</style>
